import React from 'react';
import ReinswMemberBadge from './reinsw-member-badge';
import ReviewRating from './review-rating';
import * as styles from './agent-profile-overview.style';

export type AgentProfileOverviewProps = {
  agentName: string;
  jobTitle?: string | null;
  jobCategory?: string | null;
  agencyName?: string | null;
  agencyUrl?: string | null;
  overallStarRating?: number | null;
  totalReviews?: number | null;
  isReinswMember?: boolean;
  onRatingClick?: () => void;
};

const AgentProfileOverview = ({
  agentName,
  jobTitle,
  jobCategory,
  agencyName,
  agencyUrl,
  overallStarRating,
  totalReviews,
  isReinswMember = false,
  onRatingClick,
}: AgentProfileOverviewProps): JSX.Element => {
  const role = jobTitle || jobCategory;
  const hasRating =
    typeof overallStarRating === 'number' && typeof totalReviews === 'number';
  const stackAgencyName =
    !!role && !!agencyName && !hasRating && !isReinswMember;

  return (
    <section css={styles.overview}>
      <div css={styles.profileDetails}>
        <h1 css={styles.name}>{agentName}</h1>
        {(role || agencyName) && (
          <div
            css={[
              styles.roleAndAgency,
              stackAgencyName && styles.stackedRoleAndAgency,
            ]}
          >
            {role && <span css={styles.role}>{role}</span>}
            {role && agencyName && !stackAgencyName && (
              <span css={styles.separator}>·</span>
            )}
            {agencyName && (
              <>
                {agencyUrl ? (
                  <a css={styles.agencyLink} href={agencyUrl}>
                    {agencyName}
                  </a>
                ) : (
                  <span css={styles.agencyLink}>{agencyName}</span>
                )}
              </>
            )}
          </div>
        )}
        {hasRating && (
          <ReviewRating
            overallStarRating={overallStarRating}
            totalReviews={totalReviews}
            onRatingClick={onRatingClick}
          />
        )}
        {isReinswMember && <ReinswMemberBadge />}
      </div>
    </section>
  );
};

export default AgentProfileOverview;
